import { GetCoachingHomeDashboard_coaching_coachingHomeDashboard_participants_participantMetadata_organizationTutoring } from 'coaching/queries/__generated__/GetCoachingHomeDashboard';

export type OrganizationTutoringMetadata = {
  enrolledInOrganizationTutoring: boolean;
  showOrganizationSchedulingOptions: boolean;
};

export type OrganizationTutoringData = {
  enrolledInOrganizationTutoring: boolean;
  organizationTutoring: GetCoachingHomeDashboard_coaching_coachingHomeDashboard_participants_participantMetadata_organizationTutoring | null;
};

/**
 * Check if we need to show the scheduling options for organization tutoring
 * @param {OrganizationTutoringData} organizationTutoringData
 * @returns {boolean}
 */
export const shouldShowOrganizationSchedulingOptions = (
  organizationTutoringData: OrganizationTutoringData | null
): boolean => {
  const { enrolledInOrganizationTutoring, organizationTutoring } = organizationTutoringData || {};
  return (
    !!enrolledInOrganizationTutoring && !!organizationTutoring?.selfSchedulingEnabled
  );
};

